import {
  CashInBankResponseType,
  ErrorResponse
} from 'pages/AuthorizePaymentPage/interCompany/types';

export const errorResponse: ErrorResponse = {
  httpStatusCode: '500',
  issues: [
    {
      id: '1234',
      issue: 'Company Id is missing , please contact support',
      severity: 'high'
    }
  ],
  uri: 'https://api-dev-system-url-invalid'
};

export const cashInBankResponse: CashInBankResponseType = {
  cashCompanies: [
    {
      companyId: '1',
      storeName: 'Test 1',
      storeId: 'S100106216'
    },
    {
      companyId: '2',
      storeName: 'AP Payments Store 217',
      storeId: 'S100106217'
    },
    {
      companyId: '3',
      storeName: 'Test 3',
      storeId: 'S100106299'
    }
  ],

  cashAccounts: [
    {
      companyId: '2',
      accountNumber: '3427',
      accountName: 'Chase Bank',
      postingDescriptionRequired: false,
      printerName: ''
    },
    {
      companyId: '1',
      accountNumber: '9863',
      accountName: 'Petty Cash',
      postingDescriptionRequired: false,
      printerName: ''
    },
    {
      companyId: '3',
      accountNumber: '9494',
      accountName: 'Chase Arizona',
      postingDescriptionRequired: false,
      printerName: ''
    }
  ],

  disbursementJournals: [
    {
      journalNumber: '3939',
      journalName: 'Journal test 1',
      companyId: '3',
      storeId: 'S100106216'
    },
    {
      journalNumber: '3232',
      journalName: 'Journal test 2',
      companyId: '2',
      storeId: 'S100106216'
    },
    {
      journalNumber: '9090',
      journalName: 'Journal test 3',
      companyId: '1',
      storeId: 'S100106216'
    }
  ]
};
